export * from './formSave';
export * from './ruleValidation/rule';
export { default as designerSaga } from './designerSaga';

import { all } from 'redux-saga/effects';
import formLoad from './formLoad';
import formSave from './formSave';
import formSaveAs from './formSaveAs';
import formSaveAsDraft from './formSaveAsDraft';
import formUpdateSecretKey from './formUpdateSecretKey';
import modelChange from './modelChange';

export function* rootSaga(): IterableIterator<any> {
	yield all([
		modelChange(),
		formSave(),
		formSaveAs(),
		formSaveAsDraft(),
		formLoad(),
		formUpdateSecretKey()
	]);
}
